import { StrictMode, lazy, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import { AuthProvider } from './contexts/AuthContext';
import { AnalyticsProvider } from './contexts/AnalyticsContext';

// Lazy load the main App component
const App = lazy(() => import('./App'));

// Loading component
const LoadingApp = () => (
  <div className="flex h-screen items-center justify-center bg-neutral-900">
    <div className="flex flex-col items-center">
      <div className="h-12 w-12 animate-spin rounded-full border-4 border-primary-500 border-r-transparent"></div>
      <p className="mt-4 text-white/70">Loading application...</p>
    </div>
  </div>
);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <AnalyticsProvider>
          <Suspense fallback={<LoadingApp />}>
            <App />
          </Suspense>
        </AnalyticsProvider>
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>
);